{
  "version": 1,
  "asset_id": "0ddd6296-1b9d-45f9-8461-b3e58bdd987c",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/0ddd6296-1b9d-45f9-8461-b3e58bdd987c/swim-thumbs-up.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/0ddd6296-1b9d-45f9-8461-b3e58bdd987c/swim-thumbs-up.jpg",
  "original_filename": "swim-thumbs-up.jpg",
  "size": 279063,
  "content_type": "image/jpeg",
  "created_at": "2026-07-28T15:10:31Z"
}
